<ejs-dialog
  [visible]="visible"
  width="80vw"
  height="85vh"
  cssClass="image-preview-dialog"
  [showCloseIcon]="true"
  [isModal]="true"
  [header]="''"
  (close)="close()">
  @if (imageUrl) {
    <div class="image-preview-wrap">
      <div class="image-preview-toolbar">
        <div class="image-preview-meta">
          <span class="image-preview-label">Image Preview</span>
          <span class="image-preview-name">{{ title }}</span>
        </div>
        <div class="image-preview-actions">
          <button type="button" class="image-preview-btn" (click)="downloadImage()">
            Download
          </button>
          <button type="button" class="image-preview-btn" (click)="zoomOut()">
            -
          </button>
          <button type="button" class="image-preview-btn image-preview-btn--status" (click)="resetZoom()">
            {{ (zoomLevel * 100).toFixed(0) }}%
          </button>
          <button type="button" class="image-preview-btn" (click)="zoomIn()">
            +
          </button>
          <button type="button" class="image-preview-close" (click)="close()">
            Close
          </button>
        </div>
      </div>
      <div class="image-preview-canvas">
        <img class="image-preview-image" [src]="imageUrl" [alt]="title" [style.transform]="'scale(' + zoomLevel + ')'">
      </div>
    </div>
  }
</ejs-dialog>
